import { detailEnLocale } from '@/locales/detail/details';
import { eventsEnLocale } from '@/locales/event/event';
import { homeEventsEnLocale } from '@/locales/home/home-events';
import { homeFilterEnLocale } from '@/locales/home/home-filter';
import { registerEnLocale } from '@/locales/register/register';

import { applePassEn } from './apple/apple-pass';
import { changeBrowserEnLocale } from './change-browser/change-browser.locale';
import { billingDetailsEnLocale } from './checkout/billing-details';
import { courtesyClientInfoEnLocale } from './checkout/hybrid-stepper/courtesy-client-info';
import { paymentEnLocale } from './checkout/payment';
import { pointOfSaleEnLocale } from './checkout/point-of-sale';
import { refundableTicketEnLocale } from './checkout/refundable-ticket';
import { clientInfoEnLocale } from './checkout/stepper/client-info';
import { stepperEnLocale } from './checkout/stepper/stepper';
import { totalEnLocale } from './checkout/total';
import { ErrorEnLocale } from './common/error';
import { footerEnLocale } from './common/footer';
import { navbarEnLocale } from './common/navbar';
import { notFoundEnLocale } from './common/not-found';
import { confirmEn } from './confirm/confirm.locale';
import { dateEnLocale } from './date/date';
import { searchFormEnLocale } from './events/events';
import { finishEnLocale } from './finish/finish';
import { helpEnLocale } from './help/help';
import { homeEnLocale } from './home/home';
import { loginEnLocale } from './login/login';
import { mapEnLocale } from './map/map';
import { passRecoveryEnLocale } from './pass-recovery/pass-recovery';
import { pendingPurchaseEnLocale } from './pending-purchase/pending-purchases.locale';
import { privacyEn } from './privacy-policy/privacy.locale';
import { purchasesEnLocale } from './purchases/purchases';
import { ticketsEnLocale } from './purchases/tickets';
import { refundLocaleEn } from './refund/refund.locale';
import { reservationEnLocale } from './reservation/reservation';
import { selectPositionEnLocale } from './select-position/select-position';
import { termsConditionsEn } from './terms-conditions/terms-conditions-locale';
import { updatePasswordEnLocale } from './update-password/update-password.locale';

export default {
  // common
  ...navbarEnLocale,
  ...footerEnLocale,
  // home
  ...homeEnLocale,
  ...homeFilterEnLocale,
  ...homeEventsEnLocale,
  // events
  ...eventsEnLocale,
  // help
  ...helpEnLocale,
  // detail
  ...detailEnLocale,
  // register
  ...registerEnLocale,
  // login
  ...loginEnLocale,
  // pass-recovery
  ...passRecoveryEnLocale,
  // select-position
  ...selectPositionEnLocale,
  // checkout
  ...paymentEnLocale,
  ...billingDetailsEnLocale,
  ...totalEnLocale,
  // checkout stepper
  ...stepperEnLocale,
  ...clientInfoEnLocale,
  //checkout hybrid stepper
  ...courtesyClientInfoEnLocale,
  // taquilla
  ...pointOfSaleEnLocale,
  // purchases
  ...purchasesEnLocale,
  // tickets
  ...ticketsEnLocale,
  // finish
  ...finishEnLocale,
  // reservation
  ...reservationEnLocale,
  // map
  ...mapEnLocale,
  // not-found
  ...notFoundEnLocale,
  // error
  ...ErrorEnLocale,
  // events
  ...searchFormEnLocale,
  // terms and conditions
  ...termsConditionsEn,
  // privacy policy
  ...privacyEn,
  // date
  ...dateEnLocale,
  // refund
  ...refundableTicketEnLocale,
  // confirm
  ...confirmEn,
  // apple pass
  ...applePassEn,
  // Pending purchases
  ...pendingPurchaseEnLocale,
  ...changeBrowserEnLocale,
  //update password
  ...updatePasswordEnLocale,
  // refund form
  ...refundLocaleEn,
} as const;
